const doc = [({"en":({"js":({"admin":({"orders":({"show":({"show_order":"Show order %{order_number}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;